/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParticipantNotificationStatus
 */
export interface ParticipantNotificationStatus {
    /**
     * The notification status
     * @type {string}
     * @memberof ParticipantNotificationStatus
     */
    status: ParticipantNotificationStatusStatusEnum;
    /**
     * Timestamp when the notification event was created
     * @type {Date}
     * @memberof ParticipantNotificationStatus
     */
    createdAt?: Date | null;
}


/**
 * @export
 */
export const ParticipantNotificationStatusStatusEnum = {
    Requested: 'REQUESTED',
    Sent: 'SENT',
    Failed: 'FAILED',
    Delivered: 'DELIVERED'
} as const;
export type ParticipantNotificationStatusStatusEnum = typeof ParticipantNotificationStatusStatusEnum[keyof typeof ParticipantNotificationStatusStatusEnum];


/**
 * Check if a given object implements the ParticipantNotificationStatus interface.
 */
export function instanceOfParticipantNotificationStatus(value: object): value is ParticipantNotificationStatus {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ParticipantNotificationStatusFromJSON(json: any): ParticipantNotificationStatus {
    return ParticipantNotificationStatusFromJSONTyped(json, false);
}

export function ParticipantNotificationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParticipantNotificationStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function ParticipantNotificationStatusToJSON(json: any): ParticipantNotificationStatus {
    return ParticipantNotificationStatusToJSONTyped(json, false);
}

export function ParticipantNotificationStatusToJSONTyped(value?: ParticipantNotificationStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
    };
}

